import 'css-chunksrc/client/pages/projectPage/wbsPage/styles.scss';export default {
  "listsPage": "_listsPage_1r87j_1",
  "header": "_header_1r87j_8",
  "toolbar": "_toolbar_1r87j_19",
  "heading": "_heading_1r87j_36",
  "button": "_button_1r87j_44",
  "main": "_main_1r87j_69",
  "wbs": "_wbs_1r87j_76",
  "statuses": "_statuses_1r87j_80",
  "listsList": "_listsList_1r87j_87",
  "creationMenu": "_creationMenu_1r87j_91",
  "exportButton": "_exportButton_1r87j_95"
};